jQuery(document).ready(function ($) {
  /**
   *--------------------------------------------------------------------------
   * Component: Modal
   *--------------------------------------------------------------------------
   */

  //Emegency message
  $(".js-account-takeover__toggle").on("click", function (e) {
    var is_persistent = $(this).attr("data-is-persistent");
    var takeover_uid = $(this).attr("data-uid");

    var data = {
      action: "penketh_emergency_takeover_closed",
      is_persistent: is_persistent,
      takeover_uid: takeover_uid,
    };

    $.post(ajaxurl, data, function (response) {
      console.log(response);
    });
  });
});
